
import {
    Breadcrumbs,
    ClickAwayListener,
    Grow,
    IconButton,
    Link,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Stack,
    styled,
    TablePagination,
    Typography

} from "@mui/material";

import RefreshButton from "../../../../../common/components/refresh_button";
import FormContainer from "../../../../../common/components/form_container";
import { BackButton } from "../../../../../common/components/back_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { Link as LinkTo } from "react-router";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { FormPhoneMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_phone_masked_input";
import { useMemo } from "react";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { useNovosNegociosCadastroViewModel } from "../../viewModels/novos_negocios_cadastro_view_model";
import { GenerateNovosNegociosArquivosColumns } from "./columns/generateNovosNegociosArquivo";
import { NovosNegociosArquivoLista } from "../../../domain/models/novos_negocios_arquivo_lista";
import { NovosNegociosArquivoModal } from "./components/novos_negocios_arquivo_modal";
import { DropDownCentroCusto } from "../../../../../common/components/dropdown_centro_custo";
import { DropDownCliente } from "../../../../../common/components/dropdown_cliente";
import { FormSwitchInput } from "../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { FormRadioGroupInput } from "../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";
import { DropDownFuncionario } from "../../../../../common/components/dropdown_funcionario";
import { Controller } from "react-hook-form";

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1
});

export const NovosNegociosCadastro = () => {
    const viewModel = useNovosNegociosCadastroViewModel();

    const novosNegociosArquivosColumnsDefinition = useMemo(() => {
        return GenerateNovosNegociosArquivosColumns({
            onActionEdit: viewModel.handleNovosNegociosArquivoModalOpenState,
            onActionDelete: viewModel.handleNovosNegociosArquivoDeleteOpenState,
            onActionDownload: viewModel.handleDownloadArquivoS3,
        });
    }, [
        viewModel.handleNovosNegociosArquivoModalOpenState,
        viewModel.handleNovosNegociosArquivoDeleteOpenState,
        viewModel.handleDownloadArquivoS3,
    ]);


    const tabelaNovosNegociosArquivo = useMemo(() => {
        return (
            <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                <StyledDataGrid
                    tableName="NovosNegociosArquivoCadastro"
                    disableColumnMenu={false}
                    getRowId={(row: NovosNegociosArquivoLista) => row.idNovosNegociosArquivo}
                    columns={novosNegociosArquivosColumnsDefinition}
                    loading={viewModel.loading}
                    autoHeight={true}
                    rows={viewModel.novosNegociosArquivoLista}
                    rowCount={viewModel.novosNegociosArquivoLista.length}
                    pageSizeOptions={[5]}
                    paginationMode="server"
                    paginationModel={{
                        page: viewModel.pagination.novosNegociosArquivos.page,
                        pageSize: viewModel.pagination.novosNegociosArquivos.rowsPerPage,
                    }} />

                <TablePagination
                    component="div"
                    count={viewModel.pagination.novosNegociosArquivos.totalItems}
                    page={viewModel.pagination.novosNegociosArquivos.page - 1}
                    rowsPerPageOptions={[5]}
                    onPageChange={(_, p) => viewModel.handleNovosNegociosArquivoPageChange(p)}
                    rowsPerPage={viewModel.pagination.novosNegociosArquivos.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleNovosNegociosArquivoRowsPerPageChange(parseInt(e.target.value))} />

            </div>
        );
    }, [
        viewModel,
        novosNegociosArquivosColumnsDefinition,
    ]);

    const switchSituacaoProposta = useMemo(() => {
        if (viewModel.situacaoProposta === 1) {
            return (
                <div className="w-full">
                    <FormRadioGroupInput
                        name='statusParticipar'
                        label='Situação da licitação'
                        options={[
                            { id: 0, label: 'Ganha' },
                            { id: 1, label: 'Perdida' },
                            { id: 2, label: 'Inabilitada' },
                            { id: 3, label: 'Outros' },
                        ]}
                        reactHookForm={viewModel.hookFormNovosNegocios} />
                </div>
            );
        }
        return null;
    }, [viewModel.situacaoProposta, viewModel.hookFormNovosNegocios]);

    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row w-full justify-end gap-2">
                            <BackButton onClick={() => viewModel.handlePageBack()} />
                            <div>
                                <Stack direction="row" spacing={2}>


                                    <div className="w-[12rem]">
                                        <PrimaryButton
                                            ref={viewModel.menuRef}
                                            id="composition-button"
                                            aria-controls={viewModel.openMenu ? "composition-menu" : undefined}
                                            aria-expanded={viewModel.openMenu ? "true" : undefined}
                                            aria-haspopup="true"
                                            onClick={viewModel.handleToggleMenu}
                                            buttonColor="primary-green"
                                        >
                                            Opções
                                        </PrimaryButton>
                                        <Popper
                                            style={{ zIndex: 10000 }}
                                            open={viewModel.openMenu}
                                            anchorEl={viewModel.menuRef.current}
                                            placement="bottom-start"
                                            transition
                                            disablePortal
                                        >
                                            {({ TransitionProps, placement }) => (
                                                <Grow
                                                    {...TransitionProps}
                                                    style={{
                                                        transformOrigin:
                                                            placement === "bottom-start" ? "left top" : "left bottom"
                                                    }}
                                                >
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={viewModel.handleCloseMenu}>
                                                            <MenuList
                                                                autoFocusItem={viewModel.openMenu}
                                                                id="composition-menu"
                                                                aria-labelledby="composition-button"
                                                                onKeyDown={viewModel.handleListKeyDown}
                                                            >
                                                                <MenuItem onClick={() => viewModel.handleNewNovosNegocios()}>Novo cadastro</MenuItem>
                                                                <MenuItem onClick={() => viewModel.handleNovosNegociosDeleteOpenState(true)}> Excluir </MenuItem>
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </div>
                                </Stack>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <form className="pb-8" onSubmit={viewModel.handleSalvarNovosNegocios}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Comercial
                        </Link>
                        <Link underline="hover" color="inherit" component={'span'}>
                            <LinkTo to="/NovosNegocios_lista">Novos Negócios Lista</LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Cadastro Novos Negócios
                        </Typography>
                    </Breadcrumbs>

                    <div className="flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white">
                                Novos Negócios
                            </h1>
                            <RefreshButton onClick={() => viewModel.handleReload()} />
                        </div>
                    </div>

                    {viewModel.novosNegocios && (
                        <div className="w-full mt-3 text-black dark:text-white p-4 rounded-xl bg-gray-100 dark:bg-gray-800 shadow-sm">
                            <div className="text-lg">
                                <span className="font-semibold mr-2">N° do Negócio:</span>
                                <span className="font-bold">{viewModel.novosNegocios.nrNegocio}</span>
                            </div>
                        </div>
                    )}

                    {/* STATUS */}
                    <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                        {/* INFORMAÇÕES GERAIS */}
                        <FormContainer title="Informações Gerais" arrangement="fullRow" border={false}>
                            <div className="flex flex-col items-center w-full gap-4">

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    {/* <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='nrNegocio'
                                            required={false}
                                            label='N° do Negócio'
                                            readOnly={true}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div> */}

                                    <div className="w-full">
                                        <DefaultFormInput
                                            name='titulo'
                                            required={false}
                                            label='Título'
                                            readOnly={false}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[50%]">

                                        <DropDownCentroCusto
                                            name='idCentroCusto'
                                            label='Centro de Custo'
                                            required={false}
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div>

                                    <div className="w-[50%]">
                                        <DropDownCliente
                                            name='idCliente'
                                            label='Cliente'
                                            required={false}
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />

                                    </div>
                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='nProposta'
                                            required={false}
                                            label='N° Proposta'
                                            readOnly={false}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div>

                                    <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='nEdital'
                                            required={false}
                                            label='N° Edital'
                                            readOnly={false}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div>
                                </div>



                                <div className="flex flex-row gap-4 w-full justify-between">

                                    <div className="w-[40%]">
                                        <DefaultFormInput
                                            name='cidade'
                                            required={false}
                                            label='Cidade'
                                            readOnly={false}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div>

                                    <div className="w-[30%]">
                                        <FormDatePickerInput
                                            name='data'
                                            required={false}
                                            label='Data de Inicio'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div>


                                    <div className="w-[30%]">
                                        <FormPhoneMaskedInput
                                            name='telefone'
                                            type='movel'
                                            label='Telefone Celular'
                                            reactHookForm={viewModel.hookFormNovosNegocios}
                                        />
                                    </div>
                                </div>


                            </div>

                        </FormContainer>
                        <div className="w-full flex flex-col justify-between items-start mt-8 mb-2">
                            <h1 className="font-bold text-black dark:text-white text-3xl mb-3">Informações Sobre o Processo</h1>
                            <div className="w-full">
                                <DefaultFormInput
                                    name='dadosCliente'
                                    required={false}
                                    multiline
                                    minRows={2}
                                    rows={7}
                                    label=''
                                    readOnly={false}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>
                        </div>

                        <div className="w-full flex flex-col justify-between items-start mt-8 mb-2">
                            <h1 className="font-bold text-black dark:text-white text-3xl mb-3">Análise Crítica dos Requisitos do Cliente: </h1>
                            <div className=" w-[40%] flex items-start justify-between">
                                <label className="font-medium text-gray-700">É possível atender ao escopo?:</label>
                                <FormSwitchInput
                                    activeLabel="Sim"
                                    inactiveLabel="Não"
                                    name="possivelEscopo"
                                    readOnly={viewModel.saving}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>
                            <div className=" w-[40%] flex items-start justify-between">
                                <label className="font-medium text-gray-700">É viável financeiramente?:</label>
                                <FormSwitchInput
                                    activeLabel="Sim"
                                    inactiveLabel="Não"
                                    name="viavelFinanc"
                                    readOnly={viewModel.saving}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>
                            <div className=" w-[40%] flex items-start justify-between">
                                <label className="font-medium text-gray-700">É possível atender aos prazos?:</label>
                                <FormSwitchInput
                                    activeLabel="Sim"
                                    inactiveLabel="Não"
                                    name="possivelPrazos"
                                    readOnly={viewModel.saving}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>
                            <div className=" w-[40%] flex items-start justify-between">
                                <label className="font-medium text-gray-700">É possível atender aos requisitos legais?:</label>
                                <FormSwitchInput
                                    activeLabel="Sim"
                                    inactiveLabel="Não"
                                    name="possivelReqLegais"
                                    readOnly={viewModel.saving}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>

                            <div className="w-full mt-3">
                                <DefaultFormInput
                                    name='comentarios'
                                    required={false}
                                    multiline
                                    minRows={2}
                                    rows={7}
                                    label='comentários'
                                    readOnly={false}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>
                        </div>

                        <div className="w-full flex flex-col justify-between items-start mt-8 mb-5">
                            <h1 className="font-bold text-black dark:text-white text-3xl mb-3"> Situação do Novo Negócio</h1>
                            <div className="w-full">
                                <FormRadioGroupInput
                                    name='situacaoProposta'
                                    label='Status'
                                    options={[
                                        { id: 0, label: 'Em Análise' },
                                        { id: 1, label: 'Participar da licitação' },
                                        { id: 2, label: 'Descartar' },
                                        { id: 3, label: 'Processo concluído com sucesso' },

                                    ]}
                                    reactHookForm={viewModel.hookFormNovosNegocios} />
                            </div>
                            {switchSituacaoProposta}


                            <div className="w-full">
                                <DefaultFormInput
                                    name='observacao'
                                    required={false}
                                    multiline
                                    minRows={2}
                                    rows={7}
                                    label='Observação'
                                    readOnly={false}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>

                            <div className="w-full flex flex-col gap-4 mt-3 justify-start items-start md:items-center md:flex-row">
                                <div className="w-[60%]">
                                    <DropDownFuncionario
                                        name='idFuncionario'
                                        label='Responsável Análise Crítica'
                                        required={false}
                                        readOnly={viewModel.saving}
                                        reactHookForm={viewModel.hookFormNovosNegocios}
                                    />
                                </div>

                                <div className="w-[40%]">
                                    <FormDatePickerInput
                                        name='dataSituacao'
                                        required={false}
                                        label='Data Situação'
                                        readOnly={viewModel.saving}
                                        reactHookForm={viewModel.hookFormNovosNegocios}
                                    />
                                </div>
                            </div>

                        </div>

                        {/* <div className="w-full flex flex-col justify-between items-start mt-8 mb-5">
                            <h1 className="font-bold text-black dark:text-white text-3xl mb-3">Informações Sobre o Processo</h1>
                            <div className="w-full">
                                <DefaultFormInput
                                    name='dadosCliente'
                                    required={false}
                                    multiline
                                    minRows={2}
                                    rows={6}
                                    label='Dados do Cliente'
                                    readOnly={false}
                                    reactHookForm={viewModel.hookFormNovosNegocios}
                                />
                            </div>
                        </div> */}

                        {/* ARQUIVOS DIVERSOS */}

                        {
                            viewModel.novosNegociosSelectedId &&
                            <>
                                <div className="w-full flex flex-row justify-between items-center mt-8 mb-2">
                                    <h1 className="font-bold text-black dark:text-white text-3xl">Arquivos Diversos</h1>
                                    <div>
                                        <PrimaryButton
                                            startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                            sx={{ px: 2 }}
                                            onClick={() => viewModel.handleNovosNegociosArquivoModalOpenState(null, true)}>
                                            Novo Item
                                        </PrimaryButton>
                                    </div>
                                </div>
                                {tabelaNovosNegociosArquivo}
                            </>
                        }
                    </div>

                    {
                        (viewModel.novosNegocios && viewModel.novosNegocios.nomeArquivo && viewModel.novosNegocios.nomeArquivo.length > 0) &&
                        <div className="w-full flex flex-col justify-between items-start mt-8 mb-5">
                            <h1 className="font-bold text-black dark:text-white text-3xl mb-5">Anexar Documento</h1>

                            <div className="w-[40%] justify-start mb-5">

                                <Controller
                                    name='arquivo'
                                    control={viewModel.hookFormNovosNegocios.control}
                                    render={({ field }) => (viewModel.novosNegocios && viewModel.novosNegocios.nomeArquivo && viewModel.novosNegocios.nomeArquivo.length > 0) ? (
                                        <div className="w-full flex flex-row justify-between items-center">
                                            <span className="cursor-pointer" onMouseDown={() =>
                                                viewModel.handleDownloadArquivo()}>
                                                {viewModel.novosNegocios.nomeArquivo && viewModel.novosNegocios.nomeArquivo.length > 40
                                                    ? `${viewModel.novosNegocios.nomeArquivo.substring(0, 40)}...`
                                                    : viewModel.novosNegocios.nomeArquivo}
                                            </span>
                                            <IconButton onClick={() => viewModel.handleDeleteFile()}>
                                                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
                                            </IconButton>
                                        </div>
                                    ) : (
                                        <PrimaryButton
                                            component="label"
                                            role={undefined}
                                            variant="contained"
                                            tabIndex={-1}
                                            disabled={viewModel.saving}
                                            startIcon={<DynamicIcon nameIcon="Download" size={25} className="text-white" />}>
                                            {field.value ? field.value.name : "Escolher arquivo"}
                                            <VisuallyHiddenInput
                                                type="file"
                                                onChange={(e) => viewModel.handleFileChange('nomeArquivo', 'limparArquivo', e, field.onChange)}
                                                multiple={false} />
                                        </PrimaryButton>
                                    )} />

                            </div>
                        </div>
                    }

                </div>

                <BottomBar>
                    <div className="w-full h-full flex justify-between items-center p-4 gap-6">
                        <div>
                            {/* <div>
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleOpenChangeHistory(viewModel.novosNegocios?.idNovosNegocios ?? null, null)}>
                                    <span className="text-xs">
                                        Historico de alterações
                                    </span>
                                </PrimaryButton>
                            </div> */}

                        </div>

                        <div className="w-full h-full flex justify-between items-center p-4 gap-6">
                            <div>
                                {
                                    viewModel.novosNegociosSelectedId &&
                                    <>
                                        <div>
                                            <PrimaryButton
                                                buttonColor="yellow"
                                                onClick={() => viewModel.handleOpenChangeHistory(viewModel.novosNegociosSelectedId ?? null, null)}>
                                                <span className="text-xs">
                                                    Historico de alterações
                                                </span>
                                            </PrimaryButton>
                                        </div>
                                    </>
                                }
                            </div>


                            <div className="w-[30%] flex justify-end gap-4">

                                <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                    <h1 className="text-sm text-black dark:text-white" onClick={() => viewModel.handlePageBack()}>
                                        Cancelar
                                    </h1>
                                </div>

                                {viewModel.saving ? (
                                    <PrimaryButton>Salvando...</PrimaryButton>
                                ) : (
                                    <PrimaryButton
                                        type="submit"
                                        startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
                                    >
                                        Salvar
                                    </PrimaryButton>
                                )}
                            </div>
                        </div>
                    </div>
                </BottomBar>

            </form >

            {/* Novos Negocios */}
            <DeleteDialog
                open={viewModel.openDeleteNovosNegociosModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleNovosNegociosDeleteOpenState(false)}
                title={`Você realmente deseja excluir este novos negócios?`}
                onDelete={viewModel.handleConfirmarDeletarNovosNegocios}

            />

            {/* Novos Negocios Arquivo */}
            <DeleteDialog
                open={viewModel.openDeleteNovosNegociosArquivoModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleNovosNegociosArquivoDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este arquivo?`}
                onDelete={viewModel.handleConfirmarDeletarNovosNegociosArquivo}
            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory}
            />

            <NovosNegociosArquivoModal
                open={viewModel.openNovosNegociosArquivoModal}
                saving={viewModel.saving}
                selectedNovosNegociosArquivo={viewModel.novosNegociosArquivo ?? null}
                onClose={() => viewModel.handleNovosNegociosArquivoModalOpenState(null, false)}
                onSubmit={viewModel.handleSalvarNovosNegociosArquivo}
                onOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onDownload={viewModel.handleDownloadArquivoS3}
            />


        </>
    );
};
